module.exports = __webpack_public_path__ + "img/4-1.2b16b7ca.png";